import type { TProject } from "@/zapi-frontend/stores/project";

const ORG_NAME_CONTAINS_TEST = /test/i;
const MAX_PROJECTS_IN_TEST_ORGANIZATION = 50;

export function limitProjectsForDisplay(
  projects: TProject[],
  organizationName: string | null | undefined
): TProject[] {
  if (!organizationName || !ORG_NAME_CONTAINS_TEST.test(organizationName)) {
    return projects;
  }

  const drafts = projects.filter((p) => p.isDraft);
  const nonDrafts = projects.filter((p) => !p.isDraft);
  return [...nonDrafts.slice(0, MAX_PROJECTS_IN_TEST_ORGANIZATION), ...drafts].sort((a, b) =>
    (b.lastModified || "").localeCompare(a.lastModified || "")
  );
}
